// extracted by mini-css-extract-plugin
export default {"Label":"Label-module__Label__shvKT"};